/* eslint-disable */
import magnificPopup from '../../vendor/jquery.magnific-popup';
/* eslint-enable */


export default () => {

  if ($('.modal-video-button').length) {
    $('.modal-video-button').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
          wistia: {
            index: 'wistia.com',
            id(url) {
              const m = url.match(/^.+wistia.com\/(medias)\/([^_]+)[^#]*(#medias=([^_&]+))?/);

              if (m !== null) {
                if (m[4] !== undefined) {
                  return m[4];
                }
                return m[2];
              }

              return null;
            },
            src: '//fast.wistia.net/embed/iframe/%id%?autoPlay=1'
          }
        }
      }
    });
  }


  if ($('.community-landing-hero-features .modal-gallery-button').length) {

    $('.community-landing-hero-features .modal-gallery-button').on('click', function(e) {
      e.preventDefault();

      $('.community-landing-hero-features .gallery-items').magnificPopup({
        type: 'image',
        delegate: 'a',
        gallery: {
          enabled: true,
          preload: [0, 1]
        }
      }).magnificPopup('open');

    });

  }
};
